import React from "react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="">
      <div className="ui divider" />
      <div className="ui segment footer">
        <div align="center">
          Comments/Questions?{" "}
          <p>
            <a
              href="https://twitter.com/intent/tweet?screen_name=jagrbombed&ref_src=twsrc%5Etfw"
              className="twitter-mention-button"
              data-show-count="false"
            >
              <i className="twitter icon" /> Tweet @ me!
            </a>
          </p>
          <p>
            <a rel="me" href="https://mastodon.lol/@jagrbombed">
              Follow me on Mastodon
            </a>
          </p>
          <p>
            <a href="https://post.news/jagrbombed">I am also on Post</a>
          </p>
          <p>
            Or try screaming into the void because you may get an answer quicker
            than I can check a half-dozen social media sites.
          </p>
        </div>
        <div className="ui divider" />
        <p align="center">
          Pokemon and all respective names and images are trademark and
          copyright of Nintendo 1996-{year}
        </p>
        <p align="center">
          Paldea data from <a href="http://www.serebii.net/">Serebii</a>
        </p>
        <p align="center">
          Copyright ⓒ 2022-{year} SCK
        </p>
      </div>
    </footer>
  );
}
